export default [
    'Capas',
    'Temáticas',
    'Jornadas de Desenvolvimento',
    'Seção da Biblioteca',
    'Cursos livres',
    'Depoimentos',
    'Páginas intermediárias / Conteúdos relacionados',
];
